// ==============================|| OVERRIDES - CARD CONTENT ||============================== //

export default function CardContent() {
  return {
    MuiCardHeader: {
      styleOverrides: {
        root: {
          padding: 10
        }
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: 10,
          '&:last-child': {
            paddingBottom: 10
          }
        }
      }
    }
  };
}
